import { Fence } from '@/components/markdoc/Fence'
import { InlineCode } from '@/components/markdoc/InlineCode'
import { nodes as defaultNodes } from '@markdoc/markdoc'
import { Tag } from '@markdoc/markdoc'

const nodes = {
  document: {
    render: undefined,
  },
  table: {
    ...defaultNodes.table,

    transform(node, config) {
      const attrs = node.transformAttributes(config)
      const children = node.transformChildren(config)

      return new Tag('div', { class: 'scrollable' }, [
        new Tag('table', attrs, children),
      ])
    },
  },
  th: {
    ...defaultNodes.th,
    attributes: {
      ...defaultNodes.th.attributes,
      scope: {
        type: String,
        default: 'col',
      },
    },
  },
  fence: {
    render: (props) =>
      Fence({
        ...props,
        shouldWrap: true,
        className: {
          container: 'not-prose',
          code: 'text-sm',
          'bg-color': 'bg-slate-800',
        },
      }),
    attributes: {
      language: {
        type: String,
      },
      highlights: {
        type: String,
      },
    },
  },
  code: {
    render: InlineCode,
    attributes: {
      content: { type: String },
    },
  },
}

export default nodes
